import { FunctionComponent } from "react";
import { Icon } from "@pjs/core-ui";
import { assetIcons } from "./AssetIcons.const";
import { IAssetIconProps } from "./interfaces/IAssetIconProps";

export const AssetIcon: FunctionComponent<IAssetIconProps> = (props: IAssetIconProps) => {
    const iconInfo = assetIcons.get(props.mainType, props.subType);
    return iconInfo !== null ? <Icon source={iconInfo.source} fill={iconInfo.fill} className={props.className} /> : null;
};
